import { lazy } from "react";

export const RoutePaths = [
  {
    path: "/login",
    component: lazy(() => import("../pages/Login")),
    meta: {
      authRoute: false,
      roles: ["admin", "subadmin"],
    },
  },
  // Dashboard
  {
    path: "/",
    component: lazy(() => import("../pages/DashboardOverview")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // country
  {
    path: "/country",
    component: lazy(() => import("../pages/Country/Country")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // country-Form
  {
    path: "/country-form",
    component: lazy(() => import("../pages/Country/CountryForm")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // state
  {
    path: "/state",
    component: lazy(() => import("../pages/State/State")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // state-Form
  {
    path: "/state-form",
    component: lazy(() => import("../pages/State/StateForm")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // village
  {
    path: "/village",
    component: lazy(() => import("../pages/Village/Village")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // village-Form
  {
    path: "/village-form",
    component: lazy(() => import("../pages/Village/VillageForm")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // District
  {
    path: "/district",
    component: lazy(() => import("../pages/District/District")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // District-Form
  {
    path: "/district-form",
    component: lazy(() => import("../pages/District/DistrictForm")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // Taluka
  {
    path: "/taluka",
    component: lazy(() => import("../pages/Taluka/Taluka")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // Taluka-Form
  {
    path: "/taluka-form",
    component: lazy(() => import("../pages/Taluka/TalukaForm")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // Business
  {
    path: "/business",
    component: lazy(() => import("../pages/Business/Business")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // Business-Form
  {
    path: "/business-form",
    component: lazy(() => import("../pages/Business/BusinessForm")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // Job
  {
    path: "/job",
    component: lazy(() => import("../pages/Job/Job")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // Job-Form
  {
    path: "/job-form",
    component: lazy(() => import("../pages/Job/JobForm")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // Study
  {
    path: "/study",
    component: lazy(() => import("../pages/Study/Study")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // Study-Form
  {
    path: "/study-form",
    component: lazy(() => import("../pages/Study/StudyForm")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // Help-line
  {
    path: "/helpline-number",
    component: lazy(() => import("../pages/HelplineNumber/HelplineNumber")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // Help-line Form
  {
    path: "/helpline-number-form",
    component: lazy(() => import("../pages/HelplineNumber/HelplineNumberForm")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // Help-line
  {
    path: "/donate-details",
    component: lazy(() => import("../pages/DonateDetails/DonateDetails")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // Help-line Form
  {
    path: "/donate-details-form",
    component: lazy(() => import("../pages/DonateDetails/DonateDetailsForm")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // Help-line
  {
    path: "/calendar",
    component: lazy(() => import("../pages/Calendar/Calendar")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // Help-line Form
  {
    path: "/calendar-form",
    component: lazy(() => import("../pages/Calendar/CalendarForm")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },

  // Relation
  {
    path: "/relation",
    component: lazy(() => import("../pages/Relation/Relation")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
  // Relation Form
  {
    path: "/relation-form",
    component: lazy(() => import("../pages/Relation/RelationForm")),
    meta: {
      authRoute: true,
      roles: ["admin", "subadmin"],
    },
  },
];
